/**
 * What one gallery entry IS, which decides both how it renders and which of its
 * settings the editor shows.
 *
 * Most entries are a single photo, and before this they still carried a
 * comparison pair, a synced project and an extra-photos list — thirteen
 * settings for a photo that uses four. The kind is the discriminator: each
 * kind's settings are declared against it, so a photo never has to scroll past
 * before/after fields it will not use.
 *
 * Saved entries predate the field, so an entry without one is read from what it
 * holds. That inference is what the gallery already did implicitly at render
 * (both comparison images set meant "show a comparison"), now named once and
 * shared, so the editor and the site can never disagree about an entry.
 */
type GalleryItemKind = "photo" | "before-after" | "project";

interface GalleryItemShape {
  kind?: string;
  sourceProjectId?: string;
  photos?: unknown[];
  beforeImageUrl?: string;
  afterImageUrl?: string;
}

const galleryItemKind = (item: GalleryItemShape | null | undefined): GalleryItemKind => {
  if (item?.kind === "photo" || item?.kind === "before-after" || item?.kind === "project") {
    return item.kind;
  }
  if ((item?.beforeImageUrl ?? "") !== "" && (item?.afterImageUrl ?? "") !== "") {
    return "before-after";
  }
  if ((item?.sourceProjectId ?? "") !== "" || (Array.isArray(item?.photos) && item.photos.length > 0)) {
    return "project";
  }
  return "photo";
};

export type { GalleryItemKind };
export { galleryItemKind };
